import { vdkEmHappinessPortalApi } from './vdk-em-happiness-portal-api';
const createRole = (role) => {
    return vdkEmHappinessPortalApi.post('/roles/create', role);
};
const createRoleWithPermissions = (role) => {
    return vdkEmHappinessPortalApi.post('/roles/create-role-with-permissions', role);
};
const updateRoleWithPermissions = (role) => {
    return vdkEmHappinessPortalApi.put('/roles/with-permissions', role);
};
const getAllRoles = (payload) => {
    return vdkEmHappinessPortalApi.post('roles/get-all', payload);
};
const getRoleById = (roleId) => {
    return vdkEmHappinessPortalApi.get(`/roles/${roleId}`);
};
const updateRole = (role) => {
    return vdkEmHappinessPortalApi.put('/roles', role);
};
const deleteRole = (roleId) => {
    return vdkEmHappinessPortalApi.delete(`/roles/${roleId}`);
};
const getCompanyRoles = (payload) => {
    return vdkEmHappinessPortalApi.post('/company-roles', payload);
};
export const updateRoleStatusApi = async (id) => {
    return vdkEmHappinessPortalApi.get(`/roles/${id}/toggle-active`);
};
export const getRolePermissions = async (id) => {
    return vdkEmHappinessPortalApi.get(`/roles/${id}/get-permissions`);
};
export const updateRolePermissionsApi = async (payload) => {
    return vdkEmHappinessPortalApi.post('/roles/update-permissions', payload);
};
const RoleApi = {
    createRole,
    createRoleWithPermissions,
    updateRoleWithPermissions,
    getAllRoles,
    getRoleById,
    updateRole,
    deleteRole,
    getCompanyRoles,
    getRolePermissions,
    updateRoleStatusApi,
    updateRolePermissionsApi
};
export default RoleApi;
